import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import * as appDataActions from "../../../actions/appDataActions";
import * as trackingDataActions from "../../../actions/trackingDataActions";
import * as appHelper from "../../../helpers/appHelper";
import * as objectConstants from "../../../constants/objectConstants";

class ShortResponseQuestion extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }



    render() {
        return (
            <div>
                <div className="editor-label" dangerouslySetInnerHTML={{__html: this.state.locale.prompt}}/>
                <br/>
            </div>

        );
    }
}

ShortResponseQuestion.propTypes = {
    parentObject:  PropTypes.object.isRequired,
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ShortResponseQuestion.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ShortResponseQuestion);



/** WEBPACK FOOTER **
 ** ./src/components/objects/shortResponse/ShortResponseQuestion.js
 **/